import { UserAccessRightClient } from '~/app-modules/user-access-right/clients/user-access-right-client';
import { TUserAccessRightResponse } from '~/app-modules/user-access-right/clients/dto/user-access-right-response';
import { PermissionType } from '~/app-modules/user-access-right/clients/enums/permission-type';
import { TCreateUserAccessRightRequest } from '~/app-modules/user-access-right/clients/dto/create-user-access-right-request';

@singleton()
export class UserAccessRightService {
  constructor(protected userAccessRightClient: UserAccessRightClient) {}

  async getPermissionsByUserId(userId: string): Promise<TUserAccessRightResponse[]> {
    return await this.userAccessRightClient.getPermissionsByUserId(userId);
  }

  async getPermissionsForCurrentUser(): Promise<PermissionType[]> {
    return await this.userAccessRightClient.getPermissionsForCurrentUser();
  }

  async hasGlobalEditUserRolesPermission(): Promise<boolean> {
    return await this.userAccessRightClient.hasGlobalEditUserRolesPermission();
  }

  async grant(request: TCreateUserAccessRightRequest): Promise<void> {
    return await this.userAccessRightClient.grant(request);
  }

  async revoke(userAccessRightId: string): Promise<void> {
    return await this.userAccessRightClient.revoke(userAccessRightId);
  }
}
